import { render, staticRenderFns } from "./ProductNewnessDetailCard.vue?vue&type=template&id=e97fcafc&"
import script from "./ProductNewnessDetailCard.vue?vue&type=script&lang=js&"
export * from "./ProductNewnessDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductNewnessDetailCard.vue?vue&type=style&index=0&id=e97fcafc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports